/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormualrioTipoIdentificacionCV from './controladorVista/formularioTipoIdentificacionCV';
import TablaTipoIdentificacionCV from './controladorVista/tablaTipoIdentificacionCV';
import { estadoIncial, reductor } from './reductorTipoIdentificacion';

const TipoIdentificacion: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaTipoIdentificacionCV />
        <FormualrioTipoIdentificacionCV />
    </ProveedorEstado>
);

export default TipoIdentificacion;
